import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=59b81ef7&scoped=true"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=59b81ef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b81ef7",
  null
  
)

export default component.exports